import React from "react";
import { clsx } from "clsx";
import a11y from "../../../../../shared-components/css-modules/toyota/utils/Accessibility.module.scss";
import globalStyles from "../../../../../shared-components/css-modules/toyota/styles/global.module.scss"; // Imported as module so it is scoped to our component
import { useCarConfigSelector } from "../../../../redux/store";

const LiveRegions = (): JSX.Element => {
    const liveRegions = useCarConfigSelector((state) => state.notification?.notifications);

    return (
        <ul aria-live="polite" aria-atomic="false" className={clsx(globalStyles.global, a11y["sr-only"])}>
            {liveRegions?.map((liveMessage, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`${index}-${liveMessage.title}-${liveMessage.description}`}>
                    {liveMessage.title} {liveMessage.description}
                </li>
            ))}
        </ul>
    );
};

export default LiveRegions;
